export default __webpack_public_path__ + "static/media/tv.a654fa5f.svg";